import $ from 'jquery';

export default function() {
  let $p = $('#plan-url');
  let $c = $('#county-select');
  let $s = $('#state-select');
  let states = [];
  if ($s.length > 0) {
    $.getJSON('/febassets/global/data/plan-finder.json', function(statesData) {
      states = statesData;
      $.each(states, function(i, state) {
        $s.append("<option value ='" + state.key + "'>" + state.name + '</option>');
      });
    });
    $s.change(function() {
      let selected = $(this).val();
      $c.removeAttr('disabled');
      $p.attr('disabled', true);
      $p.addClass('disabled');
      $c.find('option').remove();
      $c.append("<option value=''>-Select-</option>");
      let counties = _.find(states, function(state) {
        return state.key === selected;
      }).counties;
      $.each(counties, function(i, county) {
        let countyOption = $("<option value='" + county.url + "'>" + county.county + '</option>');
        countyOption.data('county', county);
        $c.append(countyOption);
      });
    });
    $c.change(function() {
      let selected = $(this).val();
      $p.attr('href', selected);
      $p.removeAttr('disabled');
      $p.removeClass('disabled');
    });
    /*
    $c.on('change', function() {
      let modal = $('#medicareFindPlanModal');
      var $t = $(this);
      if (
        $t.val() === '/hp/insurance/medicare/compare-plans/medicare-supplement/index.html' ||
        $t.val() === '/hp/insurance/medicare/compare-plans/journey-stride/index.html'
      ) {
        let county = $t.find('option:selected').data('county');
        $('#memberYes').attr('href', county.memberYes);
        $p.attr('disabled', true);
        $p.addClass('disabled');
        modal.modal('show');
      }
    });
    */
  }
}



// WEBPACK FOOTER //
// ./src/webpack/webapps/plan-finder.js